import { useI18n } from '@ggs/i18n'

/**
 * @typedef {import('../../definitions').DealerEntity} DealerEntity
 * @typedef {import('../../definitions').DealerListRecord} DealerListRecord
 * @typedef {import('../../definitions').LeafletPlace} LeafletPlace
 */

/**
 * @typedef {(dealers: DealerEntity[]) => DealerEntity[]} DigestDealersList
 * @typedef {(dealers: DealerEntity[]) => LeafletPlace[]} ComposeDealersLeafletPlaces
 */

/**
 * @typedef {Object} ApiDataDigestHook
 * @property {DigestDealersList} digestDealersList
 * @property {ComposeDealersLeafletPlaces} composeDealersLeafletPlaces,
 */

/**
 * Hook that process APIs data digestion / normalization.
 * @return {ApiDataDigestHook}
 */
const useApiDataDigest = () => {
  const { t } = useI18n()

  /**
   * Normalize dealers list entity records.
   *
   * @type {DigestDealersList}
   * @param {DealerListRecord[]} dealers
   * @return {DealerEntity[]}
   */
  const digestDealersList = (dealers) => {
    return dealers.map((item) => {
      return {
        id: item.dealerId || '',
        name: item.dealerName || 'Unknown Name',
        latitude: item.latitude || 0,
        longitude: item.longitude || 0,
        address1: item.address1 || 'Unknown Address1',
        address2: item.address2 || '',
        municipality: item.city || 'Unknown Municipality',
        provinceState: item.stateProvinceId || 'Unknown Province',
        postalCode: item.zipPostal || 'Unknown Postal Code',
        country: item.country || 'Unknown Country',
        contactPhone: item.phoneNumber || 'Unknown Phone',
      }
    })
  }

  /**
   * Compose leaflet place data objects from dealer entities.
   *
   * @type {ComposeDealersLeafletPlaces}
   * @param {DealerEntity[]} dealers
   * @return {LeafletPlace[]}
   */
  const composeDealersLeafletPlaces = (dealers) => {
    return dealers.map((item, index) => {
      return {
        id: item.id,
        index: index + 1,
        label: item.name,
        latitude: item.latitude,
        longitude: item.longitude,
        popupContent: null,
      }
    })
  }

  return {
    composeDealersLeafletPlaces,
    digestDealersList,
  }
}

export default useApiDataDigest
